<template>
  <div class="p-2 sm:p-3 select-none">
    <div class="flex justify-center flex-wrap">
      <div class="min-w-full sm:min-w-30 max-w-5xl m-2 flex-1">
        <div class="bg-white rounded-lg shadow-card p-4 sm:p-12">
          <h1 class="font-semibold text-2xl lg:text-3xl text-center">
            Integrations
          </h1>

          <div class="mt-12 flex justify-center">
            <section class=" bg-gray-100 rounded-lg p-6 shadow w-12/12 lg:w-6/12">
              <div class="object-contain w-7/12 mx-auto">
                <img
                    alt="salesforce"
                    src="@/assets/images/salesforce-logo.png"
                />
              </div>
              <OrderSalesForceIntegration :order="order" class="mt-4" @onRefreshAttendeesTable="getExportedAttendees"/>
            </section>

            <section
                v-if="false"
                class="flex-1 bg-gray-100 rounded-lg p-6 shadow"
            >
              <h1 class="text-center text-2xl font-semibold">Mailchimp</h1>
              <p class="mt-8">Coming soon..</p>
            </section>
          </div>

          <div
              v-if="exportedAttendees && exportedAttendees.length > 0"
              class="mt-12"
          >
            <h2 class="font-semibold text-2xl lg:text-3xl text-center">
              Exported Attendees
            </h2>

            <table class="table-fixed text-left w-full text-sm mt-12">
              <thead class="hidden md:table-header-group">
              <tr class="border-t border-b border-light-gray px-6 py-4">
                <th class="px-6 py-3">
                  <span class="text-dark-gray font-normal">FULL NAME</span>
                </th>
                <th class="px-6 py-3">
                  <span class="text-dark-gray font-normal">EMAIL</span>
                </th>
                <th class="px-6 py-3">
                  <span class="text-dark-gray font-normal">DATE</span>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr
                  v-for="(user, index) in exportedAttendees"
                  :key="index"
                  class="border-t border-light-gray"
              >
                <td class="block md:table-cell px-6 py-4 md:py-5">
                  <div class="md:hidden text-dark-gray mb-2">
                    FULL NAME
                  </div>
                  <div>{{ user.full_name }}</div>
                </td>
                <td class="block md:table-cell px-6 py-4 md:py-5">
                  <div class="md:hidden text-dark-gray mb-2">
                    EMAIL
                  </div>
                  <div>{{ user.email }}</div>
                </td>
                <td class="block md:table-cell px-6 py-4 md:py-5">
                  <div class="md:hidden text-dark-gray mb-2">
                    DATE
                  </div>
                  <div>{{ user.pivot.created_at | datetime }}</div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <!-- bottom navigation -->
          <section class="mt-16">
            <div class="flex flex-col-reverse sm:flex-row justify-between">
              <button
                  class="btn btn-secondary font-semibold rounded-lg px-10 min-w-10 mt-5 sm:mt-0"
                  @click="$emit('back')"
              >
                <span>Back</span>
              </button>
              <div>
                <button
                    v-if="order.from === 'buildabox'"
                    class="btn btn-secondary font-semibold rounded-lg px-10 min-w-10 mr-3"
                    @click="$emit('submit')"
                >
                  <span>Skip</span>
                </button>
                <button
                    :disabled="!canProceedToNextStep"
                    class="btn btn-primary font-semibold rounded-lg px-10 min-w-10"
                    @click="$emit('submit')"
                >
                  <span>Next</span>
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/common/Spinner'
import ApiV1 from '@/api/api_v1.0'
import OrderSalesForceIntegration from '@/components/order/integrations/salesforce/OrderSalesForceIntegration'

export default {
  components: {
    Spinner,
    OrderSalesForceIntegration
  },
  data () {
    return {
      activeTab        : 0,
      progressLoading  : false,
      exportedAttendees: null
    }
  },
  computed: {
    order () {
      return this.$store.state.currentEditingOrder
    },
    canProceedToNextStep () {
      return true
    }
  },
  created () {
    this.getExportedAttendees()
  },
  methods: {
    async getExportedAttendees () {
      const response = await ApiV1.getOrderExportedAttendees(this.order.uuid)
      this.exportedAttendees = response.data
    }
  }
}
</script>
